const NAMESPACE = 'CARRIER_DATA';

const SET_ALL_CARRIER_DATA = `${NAMESPACE}/SET_ALL_CARRIER_DATA`;
const SET_CARRIER_DATA = `${NAMESPACE}/SET_CARRIER_DATA`;
const SET_MOBILE_BOARDING_AVAILABLE = `${NAMESPACE}/SET_MOBILE_BOARDING_AVAILABLE`;

export {
    SET_ALL_CARRIER_DATA,
    SET_CARRIER_DATA,
    SET_MOBILE_BOARDING_AVAILABLE,
};

export default NAMESPACE;
